import React, { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import "./style.scss";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function Contact() {
  const [formData, setFormData] = useState({
    fullName: "",
    subject: "",
    email: "",
    contact: "",
    department: "",
    message: "",
  });

  const [errors, setErrors] = useState({});

  const validate = () => {
    const newErrors = {};
    if (!formData.fullName) newErrors.fullName = "Full name is required";
    if (!formData.subject) newErrors.subject = "Subject is required";
    if (!formData.email || !/\S+@\S+\.\S+/.test(formData.email))
      newErrors.email = "Valid email is required";
    if (!formData.contact || !/^\d{10}$/.test(formData.contact))
      newErrors.contact = "Valid 10-digit contact number required";
    if (!formData.department) newErrors.department = "Please select a department";
    if (!formData.message) newErrors.message = "Message is required";
    return newErrors;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
  
    if (name === "contact") {
      // Allow only digits and limit to 10 characters
      const numericValue = value.replace(/\D/g, ""); // remove non-digits
      if (numericValue.length <= 10) {
        setFormData({ ...formData, [name]: numericValue });
      }
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };
const [isSubmitting, setIsSubmitting] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
     setIsSubmitting(true); // Disable button
    try {
      await axios.post("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/submithomeform", formData);
      toast.success("We have received your message! We'll contact you within 24 hrs.");
      setFormData({
        fullName: "",
        subject: "",
        email: "",
        contact: "",
        department: "",
        message: "",
      });
    } catch (err) {
      toast.error("Sorry! Some error occurred. Please try again later.");
    } finally {
    setIsSubmitting(false); // Re-enable button
  }
  };
  return (
    <>
      <div>
      <section>
          <div className="tf-container">
            <div className="row">
              <div className="col-lg-12">
                <div className="banner-contact-v1" style={{marginTop:"0px", marginBottom:"140px", background:"none", backgroundColor:"#123841", textAlign:"center"}}>
                  <h6 style={{color:"white"}}>Still Wondering? But Knowledge is FREE</h6>
                  <p style={{color:"whitesmoke", margin:"auto", padding:"auto", maxWidth:"600px", marginBottom:"20px"}}>
                    Simply start by selecting a relevant topic to begin a spiritual journey of wisdom and knowledge with Adhigyanam.
                  </p>
                  <Link to="/journey" className="btn">
                    Start Your Journey!
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section   style={{marginBottom:"40px"}}>
          <div className="tf-container">
            <div className="row">
              <div className="col-lg-12">
                <div className="group-contact-us">
                  <div className="infor-contact-v1" style={{background:"none", backgroundColor:"transparent", padding:"0px 20px"}}>
                  <img
          src={require("../../assets/siteimages/demoimage.webp")}
          alt="images" style={{width:"100%", height:"auto", margin: "auto", padding:"auto", marginBottom:"20px"}}
        />
                  </div>
                  <div className="form-candidate" style={{padding:"0px 20px", border:"none"}}>
                  <h6 style={{fontWeight: "700",
    fontSize: "24px",
    lineHeight: "30px"}}>Need Help? We are Just a click away!</h6>
                    <p style={{marginBottom:"20px", marginTop:"6px",    fontWeight: "400",
    fontSize: "18px",
    lineHeight: "28px"
}}>Use the following form to raise a quick enquiry with our support executives. We assure to get back to you with a resolution within one Business Day.</p>
                 <form onSubmit={handleSubmit}>
      <div className="group-input">
        <div className="ip">
          <input
            type="text"
            name="fullName"
            placeholder="Full Name / Business"
            value={formData.fullName}
            onChange={handleChange} style={{ background: "#f5f5f5", color:"black" }}
          />
          {errors.fullName && <small>{errors.fullName}</small>}
        </div>
        <div className="ip">
          <input
            type="text"
            name="subject"
            placeholder="Subject Of Concern"
            value={formData.subject}
            onChange={handleChange} style={{ background: "#f5f5f5", color:"black" }}
          />
          {errors.subject && <small>{errors.subject}</small>}
        </div>
      </div>

      <div className="group-input">
        <div className="ip">
          <input
            type="text"
            name="email"
            placeholder="Email Address"
            value={formData.email}
            onChange={handleChange} style={{ background: "#f5f5f5", color:"black" }}
          />
          {errors.email && <small>{errors.email}</small>}
        </div>
        <div className="ip">
          <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
            <span style={{ position: "absolute", left: "15px", color: "#555", fontWeight: "bold" }}>
              +91
            </span>
            <input
              type="text"
              name="contact"
              placeholder="Contact No."
              value={formData.contact}
              onChange={handleChange} style={{ background: "#f5f5f5", color:"black", paddingLeft: "50px" }}
            />
          </div>
          {errors.contact && <small>{errors.contact}</small>}
        </div>
      </div>

      <div className="ip out s1">
        <select name="department" value={formData.department} onChange={handleChange} style={{ background: "#f5f5f5", color:"black" }}>
          <option value="">-- Select Department --</option>
          <option value="General Support">General Support</option>
          <option value="Account Support">Account Support</option>
          <option value="Billing Support">Billing Support</option>
          <option value="Astrologer Support">Astrologer Support</option>
          <option value="Other">Other</option>
        </select>
        {errors.department && <small>{errors.department}</small>}
      </div>

      <div className="ip out">
        <textarea
          name="message"
          placeholder="Your questions / queries or comments."
          value={formData.message}
          onChange={handleChange} style={{ background: "#f5f5f5", color:"black" }}
        />
        {errors.message && <small>{errors.message}</small>}
      </div>

     <button type="submit" disabled={isSubmitting}>
  {isSubmitting ? "Please Wait..." : "Send Message"}
</button>
    </form>
    <style>
{`
  .Toastify__close-button {
    display: none;
  }

  .Toastify__toast {
    position: relative;
    padding-right: 30px;
  }
`}
</style>
           <ToastContainer position="bottom-center"
  autoClose={5000}
  hideProgressBar={false}
  newestOnTop={false}
  closeOnClick
  rtl={false}
  pauseOnFocusLoss
  draggable
  pauseOnHover />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
       
      </div>
    </>
  );
}

export default Contact;
